<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
  <mat-card-content class="mat-mdc-card-content text-center">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-select name="categoryId" formControlName="categoryId" placeholder="Category">
              <mat-option value=""> {{ 'Select' | translate }}</mat-option>
              <mat-option [value]="cat.id" *ngFor="let cat of CategoryList">{{ cat.categoryName }}
              </mat-option>
            </mat-select>

            @if (f['categoryId'].touched && f['categoryId'].invalid) {
              <mat-hint class="m-b-16 error-msg">
                @if (f['categoryId'].errors && f['categoryId'].errors['required']) {
                  <div class="text-error"> {{ 'ChooseCategory' | translate }}</div>
                }
              </mat-hint>
            }
            <mat-label>{{ 'Category' | translate }}</mat-label>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-select name="supplierId" formControlName="supplierId" placeholder="Supplier">
              <mat-option value=""> {{ 'Select' | translate }}</mat-option>
              <mat-option [value]="cat.id" *ngFor="let cat of Suppliers">{{ cat.nameAgent }}
              </mat-option>
            </mat-select>

            @if (f['supplierId'].touched && f['supplierId'].invalid) {
              <mat-hint class="m-b-16 error-msg">
                @if (f['supplierId'].errors && f['supplierId'].errors['required']) {
                  <div class="text-error"> {{ 'ChooseSupplier' | translate }}</div>
                }
              </mat-hint>
            }
            <mat-label>{{ 'Supplier' | translate }}</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'ProductCode' | translate }}</mat-label>
            <input matInput placeholder="{{ 'ProductCode' | translate }}" formControlName="productCode"
                   maxlength="50" />

            @if(f['productCode'].touched && f['productCode'].invalid)
            {
              <mat-hint class="m-b-16 error-msg">
                @if(f['productCode'].errors && f['productCode'].errors['required'])
                {
                  <div class="text-error"> {{ 'EnterProductCode' | translate }}</div>
                }

              </mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'ProductName' | translate }}</mat-label>
            <input matInput placeholder="{{ 'ProductName' | translate }}" formControlName="productName"
                   maxlength="50" />

            @if(f['productName'].touched && f['productName'].invalid)
            {
              <mat-hint class="m-b-16 error-msg">
                @if(f['productName'].errors && f['productName'].errors['required'])
                {
                  <div class="text-error"> {{ 'EnterProductName' | translate }}</div>
                }

              </mat-hint>
            }
          </mat-form-field>
        </div>
        </div><div class="row">
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100 m-b-10">
          <mat-select name="typeOfProductName" formControlName="typeOfProductName" placeholder="measruingUnit">
            <mat-option value=""> {{ 'Select' | translate }}</mat-option>
            <mat-option [value]="unit.name" *ngFor="let unit of TypeOfProductList">{{ unit.name }}
            </mat-option>
          </mat-select>

          @if (f['typeOfProductName'].touched && f['typeOfProductName'].invalid) {
            <mat-hint class="m-b-16 error-msg">
              @if (f['typeOfProductName'].errors && f['typeOfProductName'].errors['required']) {
                <div class="text-error"> {{ 'choosemeasruingUnit' | translate }}</div>
              }
            </mat-hint>
          }
          <mat-label>{{ 'measruingUnit' | translate }}</mat-label>
        </mat-form-field>
      </div>
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'metersPerRod' | translate }}</mat-label>
            <input matInput class="txt" type="number" onwheel="return false;"
                   placeholder="{{ 'metersPerRod' | translate }} " formControlName="metersPerRod" maxlength="3"
                   minlength="1"/>

            @if (f['metersPerRod'].touched && f['metersPerRod'].invalid) {
              <mat-hint class="m-b-16 error-msg">
                @if (f['metersPerRod'].errors && f['metersPerRod'].errors['required']) {
                  <div class="text-error"> {{ 'EnterMetersPerRod' | translate }}</div>
                }
              </mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'TotalQuota' | translate }}</mat-label>
            <input matInput class="txt" type="number" onwheel="return false;"
                   placeholder="{{ 'TotalQuota' | translate }} " formControlName="totalQuota" maxlength="3"
                   minlength="1"/>

            @if (f['totalQuota'].touched && f['totalQuota'].invalid) {
              <mat-hint class="m-b-16 error-msg">
                @if (f['totalQuota'].errors && f['totalQuota'].errors['required']) {
                  <div class="text-error"> {{ 'EnterTotalQuota' | translate }}</div>
                }
              </mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'pricePerOne' | translate }}</mat-label>
            <input matInput class="txt" type="number" onwheel="return false;"
                   placeholder="{{ 'pricePerOne' | translate }} " formControlName="pricePerOne" maxlength="3"
                   minlength="1"/>

            @if (f['pricePerOne'].touched && f['pricePerOne'].invalid) {
              <mat-hint class="m-b-16 error-msg">
                @if (f['pricePerOne'].errors && f['pricePerOne'].errors['required']) {
                  <div class="text-error"> {{ 'EnterPricePerOne' | translate }}</div>
                }
              </mat-hint>
            }
          </mat-form-field>
        </div>
    </div>
      <div class="row">
        <div class="col-sm-3 divChecks">
          <mat-checkbox color="primary" formControlName="haveColor">
            {{ 'haveColor'|translate }}
          </mat-checkbox>
        </div>
        <div class="divChecks col-md-3">
          <mat-checkbox color="primary" formControlName="haveDescount">
            {{ 'haveDescount'|translate }}
          </mat-checkbox>
        </div>
      </div>
      <div class="row" *ngIf="form.controls['haveColor'].value == true">
        <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100 m-b-10">
              <mat-select name="colorId" formControlName="colorId" placeholder="Color">
                <mat-option value=""> {{ 'Select' | translate }}</mat-option>
                <mat-option [value]="color.id" *ngFor="let color of ColorList">{{ color.colorName }}
                </mat-option>
              </mat-select>

              @if (f['colorId'].touched && f['colorId'].invalid) {
                <mat-hint class="m-b-16 error-msg">
                  @if (f['colorId'].errors && f['colorId'].errors['required']) {
                    <div class="text-error"> {{ 'ChooseColor' | translate }}</div>
                  }
                </mat-hint>
              }
              <mat-label>{{ 'Color' | translate }}</mat-label>
            </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="divImg">
            <div class="image-container" *ngIf="imgURL">
              <img [src]="imgURL" width="100%" height="100%" class="mat-mdc-card-image mdc-card__media"/>
            </div>
          </div>
        </div>
      </div>

      <div class="row m-t-10">
        <mat-label>{{ 'SelectItemFile' | translate }}</mat-label>
        <div class="dzu-dropzone">
          <label class="dzu-inputLabel">
            {{ 'SelectItemFile'| translate }}
            <input class="dzu-input" type="file" accept="image/*" (change)="onFileSelected($event)"></label>
        </div>

        @if (f['imgURL'].touched && f['imgURL'].invalid) {
          <mat-hint class="m-b-16">
            @if (f['imgURL'].errors && f['imgURL'].errors['required']) {
              <div class="text-error"> {{ 'UploadProductImg' | translate }}</div>
            }
          </mat-hint>
        }

      </div>
      <mat-divider></mat-divider>

      <div class="row m-t-24">
        <div class="col-sm-12">
          <button mat-flat-button color="primary" class="orangSavebtn" (click)="submit()">
            {{ 'Save' | translate }}
          </button>

          <button mat-button class="Cancelbtn" (click)="Cancel()"> {{ 'Cancel' | translate }}</button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
